import * as Icons from '@/components/Icons/ActionDimensions'
import { TileVariantTypes } from '@/utils/variants/TileVariants'

export const ActionDimensionsColorMap: Record<string, TileVariantTypes> = {
  ecology: 'green',
  economy: 'burgundy',
  society: 'sahara',
} as const

export const ActionDimensionsIconMap = {
  ecology: Icons.Ecology,
  economy: Icons.Economy,
  society: Icons.Society
}
